import { SPOT_ILLUSTRATION } from '@george-labs.com/george-assets/illustrations';

import type { BankMessage } from '@shared/bank-messages-utils';

const BANK_MESSAGE_TYPE_TO_ILLUSTRATION: Record<
    NonNullable<BankMessage['type']>,
    SPOT_ILLUSTRATION
> = {
    DESIGN_CHANGE: SPOT_ILLUSTRATION.PAINT_ROLLER,
    FEATURE_ANNOUNCEMENT: SPOT_ILLUSTRATION.ROCKET,
    FRAUD_WARNING: SPOT_ILLUSTRATION.LOCK_COINS,
    MAINTENANCE: SPOT_ILLUSTRATION.BLUEPRINT,
    PAYMENT_ISSUE: SPOT_ILLUSTRATION.MONEY_BILL_WARNING,
    INVESTMENT_INFO: SPOT_ILLUSTRATION.GRAPH_LINE,
    GENERAL: SPOT_ILLUSTRATION.INFO_CIRCLE,
};

export const getMustReadMessageIllustration = (type: BankMessage['type']): SPOT_ILLUSTRATION => {
    if (!type) {
        return SPOT_ILLUSTRATION.INFO_CIRCLE;
    }

    return BANK_MESSAGE_TYPE_TO_ILLUSTRATION[type] ?? SPOT_ILLUSTRATION.INFO_CIRCLE;
};
